import { useKeycloak } from "@react-keycloak/web";

interface PrivateWrapperProps {
  children: React.JSX.Element | React.JSX.Element[];
}

const PrivateWrapper = (props: PrivateWrapperProps): React.JSX.Element => {
  const { children } = props;
  const { keycloak, initialized } = useKeycloak();

  const isLoggedIn = keycloak.authenticated;

  if (isLoggedIn) {
    return <>{children}</>;
  } else {
    if (initialized) {
      keycloak.login();
    }
    return <></>;
  }
};

export default PrivateWrapper;
